import { render, staticRenderFns } from "./FTPCsRes.vue?vue&type=template&id=723ed529&scoped=true&"
import script from "./FTPCsRes.vue?vue&type=script&lang=js&"
export * from "./FTPCsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ed529",
  null
  
)

export default component.exports